import { render, staticRenderFns } from "./dsfDialog.vue?vue&type=template&id=180b5d70&"
import script from "./dsfDialog.vue?vue&type=script&lang=js&"
export * from "./dsfDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/dialog/dsfDialog.vue"
export default component.exports